import { Controller } from '@hotwired/stimulus'
import { track, trackSegment } from '../utils/track'
import { isValidPostcode } from 'utils/postcode'
import uuidv1 from 'uuid/v1'

export default class extends Controller {
  static targets = ['form', 'input', 'error']

  connect() {
    this.formId = uuidv1()
    this.formName = this.formTarget.dataset.trackingId
    this.landingFormProps = {
      form_id: this.formName,
      form_name: this.formName,
      form_type: 'comparison_journey',
      form_step_name: 'broadband_address_form',
      form_step_id: 'broadband_address_form-001',
      form_started_id: this.formId,
      form_is_step_skipped: false,
      form_step_field: [
        {
          id: 'postcode-input',
          label: '',
          value: '',
          type: 'text'
        }
      ],
      org_brand: 'uswitch',
      org_product_category: 'broadband',
      org_subvertical: 'broadband',
      org_vertical: 'communications',
      org_vertical_group: 'home_services'
    }

    trackSegment('Form Loaded', {
      ...this.landingFormProps
    })
  }

  submit(event) {
    let error = !isValidPostcode(this.inputTarget.value)

    if (error) {
      track('Broadband - Postcode Capture', 'Incorrect Postcode')
      this.errorTarget.style.display = 'block'
      trackSegment('Form Errored', {
        submit_id: this.formId,
        form_name: this.formName,
        form_started_id: this.formId,
        form_error_text: 'Please try re-entering your postcode in the correct format e.g. SE1 2LH'
      })
      event.preventDefault()
      return false
    }

    trackSegment('Form Submitted', {
      ...this.landingFormProps,
      form_step_field: [
        {
          id: 'postcode-input',
          label: '',
          value: this.inputTarget.value,
          type: 'text'
        }
      ]
    })
  }

  privacyPolicyTrackClick() {
    trackSegment('Element Clicked', {
      element_name: 'Privacy Policy',
      element_text: 'Privacy Policy',
      element_type: 'link'
    })
  }

  changeValue() {
    track('Broadband - Postcode Capture', 'Change Postcode')
  }
}
